import * as z from "zod";

import { dateSchema, requiredString, REQUIRED_MESSAGE } from "components/form/utils";

export const referenceObject = () =>
    z
        .object({
            id: requiredString(),
        })
        .or(z.literal(undefined))
        .or(z.literal(null))
        .or(z.literal(""))
        .refine((val) => !!val && !!val.id?.trim(), {
            message: REQUIRED_MESSAGE,
        });

export const interviewSchema = z.object({
    title: z.string().optional().nullable(),
    status: requiredString(),
    applicant: referenceObject(),
    recording_url: z.string().optional().nullable(),
    date_scheduled: dateSchema,
    client_feedback: z.string().optional().nullable(),
    internal_feedback: z.string().optional().nullable(),
    transcript: z.string().optional().nullable(),
    is_cleared: z.boolean().optional().nullable(),
});
